import { PAGES } from './pages';

export const PAYMENT_PLATFORMS = {
  HIPAY: 'HIPAY',
  PAY_JUNCTION: 'PAY_JUNCTION', // we must use the 'action' and not the 'pickId'
  CSR_PAY_JUNCTION: 'CSR_PAY_JUNCTION',
  STRIPE: 'STRIPE',
  ADYEN: 'ADYEN',
  NO_VALIDATION: 'NO_VALIDATION',
  ADYEN_APPLEPAY: 'ADYEN_APPLEPAY',
  ADYEN_TWINT: 'ADYEN_TWINT',
  ADYEN_APPLE_QUICK_PAY: 'ADYEN_APPLE_QUICK_PAY',
  CART_ZERO: 'CART_ZERO'
} as const;

export const PAYJUNCTION_RESPONSE_CODES = {
  APPROVED: '00'
} as const;

export const ADYEN_PAYMENT_STATES = {
  AUTHORISED: 'Authorised',
  PENDING: 'Pending',
  REFUSED: 'Refused',
  ERROR: 'Error'
} as const;

export const PAYMENT_STATES = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  FORWARDING: 'forwarding',
  DECLINED: 'declined',
  ERROR: 'error'
} as const;

export const PAYMENT_STATUS = {
  RISK_CHALLENGE: '112'
} as const;

export const PAYMENT_ERRORS = {
  SHIPPING_ERR: '1006',
  BILLING_ERR: '1007',
  DELAYED_DELIVERY_ERROR: '2600'
} as const;

export const STEPS = {
  CART: 'cart',
  LOGIN: 'login',
  SHIPPING_ADDRESS: 'address',
  BILLING_ADDRESS: 'billing',
  SHIPPING_MODE: 'shipping',
  REVIEW: 'review',
  PAYMODE: 'pay',
  REPORT: 'report'
} as const;

export const PAGENAME = {
  CART: 'Cart',
  LOGIN: 'tunnel',
  SHIPADDRESS: 'tunnel',
  BILLADDRESS: 'tunnel',
  SHIPMODE: 'tunnel',
  REVIEW: 'tunnel',
  PAYMODE: 'tunnel',
  REPORT: 'Confirmation'
} as const;

export const STEP_CHANGE = {
  PREV: 'prev',
  NEXT: 'next'
} as const;

export const DISCOUNT_CODE = {
  FREE_SHIPPING: 'FREE_SHIPPING',
  OFFERED_ITEMS: 'OFFERED_ITEMS'
} as const;

export const CHECKOUT_ROUTE = `${PAGES.CHECKOUT}/[step]`;
